export default "__VITE_ASSET__C6VXirxe__"